import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  PrimaryButton,
  Text,
  Heading,
  Box,
  Link,
  Panel,
  PanelContent,
} from 'components';
import { useAnalytics } from 'components/Tracking';

function ConfirmEmail(props) {
  const {
    email,
    contactUrl,
    onConfirm,
  } = props;

  const analytics = useAnalytics();

  useEffect(() => {
    analytics.onPageView('EmailConfirmation'); // FIXME fake pageview cause this is not a real view
  }, []);

  return (
    <Panel textAlign="center">
      <Box mb="medium">
        <Heading id="createAccount" fontSize="sectionHeading" />
      </Box>

      <PanelContent>
        <Text id="createAccount.confirmEmail.content" />
        <Box row my="medium">
          <Text color="brand" bold fontSize="normal">
            {email}
          </Text>
        </Box>

        <PrimaryButton variant="brand" onClick={onConfirm}>
          <Text id="createAccount.confirmEmail.submit" />
        </PrimaryButton>

        <Box m="fine">
          <Text
            fontSize="fine"
            id="createAccount.confirmEmail.notYourEmail"
            values={{
              contactLink: (
                <Link key="contactUrl" href={contactUrl} id="contact" />
              ),
            }}
          />
        </Box>
      </PanelContent>
    </Panel>
  );
}

ConfirmEmail.propTypes = {
  email: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  contactUrl: PropTypes.string.isRequired,
};

export default React.memo(ConfirmEmail);
